
import { Component, Vue } from 'vue-property-decorator'
import DatePicker from '@/components/date-picker.vue'
import {
    apiSupplierLists,
    apiSupplierAdd,
    apiGetCategory,
    apiKpGoodsClassify,
    apiEditCategory,
    apiGetBindShop,
    apiEditBindShop,
    apiEditPassword
} from '@/api/supplier'
import { apiShopLists } from '@/api/shop'
import { RequestPaging } from '@/utils/util'
import { OrderType } from '@/utils/type'
import LsPagination from '@/components/ls-pagination.vue'
import LsDialog from '@/components/ls-dialog.vue'
@Component({
    components: {
        DatePicker,
        LsPagination,
        LsDialog
    }
})
export default class Lists extends Vue {
    $refs!: { dialog: any; form: any; editCategory: any; bindShop: any }
    // S Data
    activeName: any = 'all' //全部;
    value: any = [1]

    tabs = [
        {
            label: '全部',
            name: 'all'
        },
        {
            label: '待付款',
            name: OrderType[0]
        },
        {
            label: '已完成',
            name: OrderType[1]
        }
    ]
    cascaderValue: any = []
    pager = new RequestPaging()

    tabCount = {
        all: 0, //全部
        wait: 0, //待支付
        finish: 0 //已关闭
    }
    editCategory: any = []
    categoryForm: any = {
        categoryDTOs: [],
        supplierId: ''
    }
    bindShopForm: any = {
        id: [],
        supplierId: ''
    }
    form: any = {
        startCreateDate: '',
        endCreateDate: '',
        state: '',
        directorName: '',
        directorPhone: '',
        name: '',
        phone: '',
        sid: '',
        categoryFirstId: '',
        categorySecondId: '',
        categoryThirdId: ''
    }
    creatForm: any = {
        description: '', //简介
        directorName: '', //负责人姓名
        directorPhone: '', //负责人电话
        name: '', //供应商店铺名称
        phone: '',
        username: '',
        password: '',
        repeatPassword: '',
        state: 0
    }
    data: any = []
    total: any = 0
    pageSize: any = {
        page: 0,
        size: 10
    }
    shopList: any = []
    rules: any = {
        name: [{ required: true, message: '请输入供应商名称', trigger: 'blur' }],
        directorPhone: [{ required: true, message: '请输入负责人电话', trigger: 'blur' }],
        directorName: [{ required: true, message: '请输入负责人姓名', trigger: 'blur' }],
        username: [{ required: true, message: '请输入供应商账号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        repeatPassword: [{ required: true, message: '请输入重复密码', trigger: 'blur' }]
    }
    propres = {
        checkStrictly: true,
        lazy: true,
        multiple: true,
        async lazyLoad(node: any, resolve: any) {
            const level = node.level
            const parentId = node.value
            let options: any
            if (level == 0) {
                apiKpGoodsClassify({ id: 0 }).then(res => {
                    options = res.map((item: any) => ({
                        value: item.id,
                        label: item.name,
                        leaf: level >= 2
                    }))
                    resolve(options)
                })
            } else if (level == 1) {
                const params = {
                    id: parentId
                }
                apiKpGoodsClassify(params).then(res => {
                    options = res.map((item: any) => ({
                        value: item.id,
                        label: item.name,
                        leaf: level >= 2
                    }))
                    resolve(options)
                })
            } else if (level == 2) {
                const params = {
                    id: parentId
                }
                apiKpGoodsClassify(params).then(res => {
                    options = res.map((item: any) => ({
                        value: item.id,
                        label: item.name,
                        leaf: level >= 2
                    }))
                    resolve(options)
                })
            } else {
                resolve()
            }
        }
    }
    propres2 = {
        checkStrictly: true,
        lazy: true,
        async lazyLoad(node: any, resolve: any) {
            const level = node.level
            const parentId = node.value
            let options: any
            if (level == 0) {
                apiKpGoodsClassify({ id: 0 }).then(res => {
                    options = res.map((item: any) => ({
                        value: item.id,
                        label: item.name,
                        leaf: level >= 2
                    }))
                    resolve(options)
                })
            } else if (level == 1) {
                const params = {
                    id: parentId
                }
                apiKpGoodsClassify(params).then(res => {
                    options = res.map((item: any) => ({
                        value: item.id,
                        label: item.name,
                        leaf: level >= 2
                    }))
                    resolve(options)
                })
            } else if (level == 2) {
                const params = {
                    id: parentId
                }
                apiKpGoodsClassify(params).then(res => {
                    options = res.map((item: any) => ({
                        value: item.id,
                        label: item.name,
                        leaf: level >= 2
                    }))
                    resolve(options)
                })
            } else {
                resolve()
            }
        }
    }
    // E Data

    // S Methods
    reset() {
        this.form = {
            startCreateDate: '',
            endCreateDate: '',
            state: '',
            directorName: '',
            directorPhone: '',
            name: '',
            phone: ''
        }
        this.pageSize = {
            page: 0,
            size: 10
        }
        this.getSupplierLists(0)
    }

    updatePassword(id: number | any) {
        this.$alert('是否供应商重置密码？', '重置密码', {
            confirmButtonText: '确定',
            callback: action => {
                console.log(action)
                if (action == 'confirm') {
                    apiEditPassword({ supplierId: id }).then(res => {
                        this.$message.success('重置成功')
                    })
                }
            }
        })
    }
    editCategoryConfirm() {
        if (this.editCategory.length == 0) {
            this.$message.error('请选择分类')
            return
        }
        apiEditCategory(this.categoryForm).then(res => {
            this.$message.success('修改成功')
            this.getSupplierLists(0)
            this.editCategory = []
            this.categoryForm = {
                categoryDTOs: [],
                supplierId: ''
            }
            this.$refs.editCategory.visible.val = false
        })
    }
    getShopName(sid: any) {
        const arr = this.shopList
            .filter((item: any) => {
                return sid.includes(`${item.id}`)
            })
            .map((item: any) => item.name)
            .join('、')
        return arr
    }
    getcategoryName(data: any) {
        const arr = data.map((item: any) => {
            if (item.categoryThirdId) {
                return item.categoryThirdName
            } else if (item.categorySecondId) {
                return item.categorySecondName
            } else if (item.categoryFirstId) {
                return item.categoryFirstName
            }
        })
        return arr.join('、')
    }
    openeditCategory(row: any) {
        // apiGetCategory({ supplierId: row.id })
        //     .then(res => {
        //         this.editCategory = res.map((item: any) => {
        //             if (item.categoryThirdId) {
        //                 return [item.categoryFirstId, item.categorySecondId, item.categoryThirdId]
        //             } else if (item.categorySecondId) {
        //                 return [item.categoryFirstId, item.categorySecondId]
        //             } else if (item.categoryFirstId) {
        //                 return [item.categoryFirstId]
        //             }
        //         })
        //     })
        //     .catch(rej => {
        //         this.editCategory = []
        //     })
        this.$refs.editCategory.open()
        this.categoryForm.supplierId = row.id
    }
    editCategorycancel() {
        this.editCategory = []
        this.categoryForm = {
            categoryDTOs: [],
            supplierId: ''
        }
    }
    openBindShop(row: any) {
        this.$refs.bindShop.open()
        this.bindShopForm.supplierId = row.id
        apiGetBindShop({ supplierId: row.id }).then(res => {
            this.bindShopForm.id = res.map((item: any) => item.id)
        })
    }
    bindShopConfirm() {
        // if (this.bindShopForm.id.length == 0) {
        //     this.$message.error('请选择商户')
        //     return
        // }
        apiEditBindShop({
            supplierId: this.bindShopForm.supplierId,
            sid: [...this.bindShopForm.id]
        }).then(res => {
            this, this.$message.success('修改成功')
            this.getSupplierLists(0)
            this.$refs.bindShop.visible.val = false
        })
    }
    bindShopcancel() {
        this.bindShopForm = {
            id: [],
            supplierId: ''
        }
    }
    getSupplierLists(page?: number) {
        page == 0 && (this.pageSize.page = page)
        apiSupplierLists({
            ...this.form,
            ...this.pageSize
        }).then(res => {
            this.data = res.rows
            this.total = +res.total
        })
    }
    cascaderChange(data: any) {
        this.form.categoryThirdId = data[2]
        this.form.categorySecondId = data[1]
        this.form.categoryFirstId = data[0]
    }
    cascaderChange2(data: any) {
        this.categoryForm.categoryDTOs = data.map((item: any) => {
            return {
                categoryThirdId: item[2] || '',
                categorySecondId: item[1] || '',
                categoryFirstId: item[0] || ''
            }
        })
    }
    handleSizeChange(size: any) {
        this.pageSize.size = size
        this.getSupplierLists(0)
    }
    handleCurrentChange(page: any) {
        this.pageSize.page = page - 1
        this.getSupplierLists()
    }
    creatFormReset() {
        this.creatForm = {
            description: '',
            directorName: '',
            directorPhone: '',
            name: '',
            phone: '',
            username: '',
            password: '',
            repeatPassword: '',
            state: 0
        }
    }
    handleConfirm() {
        this.$refs.form.validate((v: any) => {
            if (v) {
                if (this.creatForm.repeatPassword !== this.creatForm.password) {
                    this.$message.warning('两次密码不一致')
                } else {
                    apiSupplierAdd(this.creatForm).then(res => {
                        this.$refs.dialog.close()
                        this.creatFormReset()
                    })
                }
            }
        })
    }
    // E Methods

    // S  life cycle

    async created() {
        await apiShopLists({}).then(res => {
            this.shopList = res.lists
        })
        this.getSupplierLists(0)
    }

    // E life cycle
}
